import { mapGetters } from "vuex";

export default {
  install: function(app /*, options*/) {
    app.mixin({
      computed: {
        ...mapGetters(["trackers"]),
        apriContoUrl() {
          if (this.trackers.codice) {
            return (
              process.env.VUE_APP_PLUGIN_APRICONTO_CONVENZIONE + this.trackers.codice
            );
          } else {
            return (
              process.env.VUE_APP_APRICONTO
            );
          }
        }
      }
    });
  }
};
